import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import getDerivedFromMeasurementsConfig from 'Components/Worksheets/OversizeDeterminationWorksheet/derivedFromMeasurementsConfig';
import qestIds from '../../../QestIds';
import getMeasuredUsingConfig from '../../measuredUsingConfig';

const getConfig = (prefix: string) =>
  mergeConfig(
    {
      [`${prefix}.Sieves.CumulativeDryMassRetainedPercent`]: { format: { nearest: 1 } },
    },
    getMeasuredUsingConfig(prefix),
    getDerivedFromMeasurementsConfig(prefix),
    {
      [`${prefix}.Equipment.Balance`]: { defaultReadability: 1, defaultUom: 'g' },
    }
  );

export { getConfig };

export default {
  [qestIds.oversizeDetermination.ARIZ_225d_245c]: getConfig,
};
